<template>
    <div class="orderinfo_content">
        <div class="orderinfo_box">
            <div class="orderinfo_title_content"><h3>填写订单信息</h3></div>
            <div class="orderinfo_info_content">
                <Form ref="submit" :model="submit" :label-width="120">
                    <FormItem label="交货日期：" prop="delivertime" :rules="{required: (is_sendtime == 1 ? true : false), trigger: 'change'}">
                        <DatePicker type="date" v-model="submit.delivertime" :options="prohibitdata" :editable="false" placeholder="选择交货日期" @on-change="dateChange"></DatePicker>
                    </FormItem>
                    <FormItem label="收货地址：">
                        <div class="orderinfo_list_content" v-for="(item, index) in addresslist" :key="index">
                            <div class="orderinfo_list_box" :class="{'active': item.selected}" v-if="index == 0 || addressShow" @click="selectaddress(item, index)">
                                <div class="orderinfo_list"><span>{{item.fathercodename + item.cityadcodename + item.adcodename + item.detaddress}}</span></div>
                                <div class="orderinfo_list"><small>{{item.contactname}}</small><small>{{item.phone}}</small></div>
                                <div class="orderinfo_list"><b>{{item.shopname}}</b></div>
                            </div>
                        </div>
                        <div class="orderinfo_btn_content">
                            <span @click="showalladdressClick" v-if="addresslist.length >= 2 && !addressShow">显示全部</span>
                            <span @click="showalladdressClick" v-else>收起</span>
                            <span @click="newaddressClick">新建地址</span>
                        </div>
                    </FormItem>
                    <FormItem label="发票信息：" v-if="submit.billset.status == 1 || (submit.billset.is_sptcommen == 0 && submit.billset.is_sptzeng == 0)">
                        <Select v-model="billed" style="width: 192px" @on-change="billChange">
                            <Option value="0">不开发票</Option>
                            <Option value="1" v-if="submit.billset.is_sptcommen == 1">增值税普通发票（{{submit.billset.commentaxrate}}%税点）</Option>
                            <Option value="2" v-if="submit.billset.is_sptzeng == 1">增值税专用发票（{{submit.billset.zengtaxrate}}%税点）</Option>
                        </Select>
                        <div class="invoice_info_content" v-if="billed == 1 && submit.billset.is_sptcommen == 1 || billed == 2 && submit.billset.is_sptzeng == 1">
                            <i class="icon iconfont icon-bianji" @click="invoiceClick"></i>
                            <p>
                                <span>发票抬头：{{submit.billinfo.billtitle}}</span>
                                <span>纳税人识别号：{{submit.billinfo.billnumber}}</span>
                                <span v-if="billed == 2">注册地址：{{submit.billinfo.regaddress}}</span>
                                <span v-if="billed == 2">注册电话：{{submit.billinfo.regphone}}</span>
                                <span v-if="billed == 2">开户银行：{{submit.billinfo.bankname}}</span>
                                <span v-if="billed == 2">银行账号：{{submit.billinfo.banknumber}}</span>
                                <span>发票内容：{{submit.billinfo.billcontent}}</span>
                            </p>
                        </div>
                    </FormItem>
                    <FormItem label="优惠券：" v-if="couponlist.length > 0">
                        <div class="orderinfo_coupon_content">
                            <ul class="orderinfo_coupon_box" :style="{height: couponheight ? 'auto' : ''}">
                                <Poptip trigger="hover" word-wrap :disabled="item.availstatus == 1" :content="item.reason" width="240" v-for="(item, index) in couponlist" :key="index">
                                    <li
                                        :class="{'no': item.availstatus == 0, 'active': item.checked}"
                                        @click="selectcoupon(item, index)">
                                        <div class="orderinfo_coupon_top">
                                            <div class="orderinfo_coupon_price">￥{{item.cost}}</div>
                                            <div class="orderinfo_coupon_info">
                                                <span v-if="item.limitcost > 0">满{{item.limitcost}}可用</span>
                                                <span v-else>无限制</span>
                                                <small>有效期至{{item.edatex}}</small>
                                            </div>
                                        </div>
                                        <div class="orderinfo_coupon_bottom">
                                            <span>{{item.goodsrangevaluestr}}</span>
                                            <span @click.stop="seecouponinfo(item)">更多</span>
                                        </div>
                                        <i class="icon iconfont icon-xingzhuangjiehe"></i>
                                    </li>
                                </Poptip>
                            </ul>
                            <span v-if="couponlist.length >= 2 && !couponheight" @click="couponshow">显示全部</span>
                            <span v-else @click="couponshow">收起</span>
                        </div>
                    </FormItem>
                    <FormItem label="备注：">
                        <Input v-model="submit.content" type="textarea" :rows="4" placeholder="输入商品备注信息" style="width: 400px;" />
                    </FormItem>
                </Form>
            </div>
        </div>
        <div class="h20"></div>
        <div class="orderinfo_box">
            <div class="orderinfo_title_content"><h3>填写订单信息</h3></div>
            <div class="orderinfo_goodsinfo_content">
                <div class="orderinfo_goodsinfo_box" :style="{'height': tableShow ? 'auto' : ''}">
                    <Table
                        border
                        ref="selection"
                        :columns="thead"
                        :data="goodslist"></Table>
                </div>
                <div class="orderinfo_goodsinfo_btn" v-if="this.goodslist.length > 1"><span @click="showalltable">共{{goodscount}}种{{goodsallnum}}个商品<template v-if="sendgitf == 1">(含赠品）</template></span></div>
            </div>
        </div>
        <div class="h20"></div>
        <div class="orderinfo_footer_content">
            <div class="orderinfo_footer_box">
                <div class="orderinfo_footer_left">
                    <div class="orderinfo_footer_list"><span>商品金额：</span><b>{{parseFloat(goodsallcost).toFixed(2)}}元</b></div>
                    <div class="orderinfo_footer_list"><span>税费：</span><b>+{{parseFloat(taxation).toFixed(2)}}元</b></div>
                    <div class="orderinfo_footer_list"><span>运费：</span><b>+{{parseFloat(pscost).toFixed(2)}}元</b></div>
                    <div class="orderinfo_footer_list"><span>优惠金额：</span><b>-{{parseFloat(shopcxcost).toFixed(2)}}元</b></div>
                    <div class="orderinfo_footer_list"><span>优惠券金额：</span><b>-{{parseFloat(couponcost).toFixed(2)}}元</b></div>
                </div>
                <div class="orderinfo_footer_right">
                    <div class="orderinfo_footer_money">
                        <span>订单金额：</span>
                        <b>{{orderprice}}元</b>
                    </div>
                    <Button type="warning" @click="submitorder">立即下单</Button>
                </div>
            </div>
        </div>
        <!-- 新建地址 -->
        <NewAddress :newaddresshows="newaddresshows" @newaddressOk="newaddressOk" @newaddressCancel="newaddressCancel"></NewAddress>
        <!-- 修改发票信息 -->
        <Invoice :invoiceshows="invoiceshows" :billed="billed" :billinfo="submit.billinfo" @invoiceOk="invoiceOk" @invoiceCancel="invoiceCancel"></Invoice>
        <!-- 优惠券信息 -->
        <SeeCoupon :couponShow="couponShow" :couponinfo="couponinfo" @couponCancel="couponCancel"></SeeCoupon>
    </div>
</template>

<script>
import api from '@/request/api.js'
import NewAddress from '@/components/component/popup/newaddress.vue'
import Invoice from '@/components/component/popup/invoice.vue'
import SeeCoupon from '@/components/component/popup/seecoupon.vue'
import {toMoney} from '@/filter/moneyFilter.js'
export default {
    components: {NewAddress, Invoice, SeeCoupon},
    data() {
        return {
            newaddresshows: false, // 新建地址弹窗是否显示
            invoiceshows: false, // 编辑发票信息
            prohibitdata: { // 日期选择器禁止选择之前日期
                disabledDate (date) {
                    return date && date.valueOf() < Date.now() - 86400000
                }
            },
            is_sendtime: 0, // 交货日期是否必填 0 选填 1必填
            addressShow: false, // 收货地址 展开/收起
            addresslist: [], // 收货地址列表
            couponheight: false, // 展开全部优惠券
            couponlist: [], // 优惠券列表
            thead: [ // 表格头部
                {
                    width: 520,
                    title: '商品',
                    key: 'goods',
                    render: (h, params) => {
                        return h('div', // 商品
                                    [
                                        h('div', // 商品图片
                                            {
                                                class: 'shoppingcart_goods_left',
                                                style: {
                                                    backgroundImage: 'url(' + params.row.img + ')',
                                                },
                                                on: {
                                                    click: () => {
                                                        this.goto(params.row.goodsid)
                                                    }
                                                },
                                            }
                                        ),
                                        h('div', // 商品右侧信息
                                            {
                                                class: 'shoppingcart_goods_right'
                                            },
                                            [
                                                h('span', // 商品名称
                                                    {
                                                        class: 'shoppingcart_goods_name'
                                                    },
                                                    [
                                                        h('b',
                                                            {
                                                                style: {
                                                                    backgroundColor: params.row.cxinfo.type == 1 ? '#FF8000' : '#40a250',
                                                                    display: params.row.cxinfo.is_cx == 1 ? 'inline' : 'none'
                                                                }
                                                            },
                                                            params.row.cxinfo.type == 1 ? '特价' : (params.row.cxinfo.type == 2 ? '折扣' : '')
                                                        ),
                                                        h('b', {style: {
                                                                    backgroundColor: params.row.is_send == 1 ? '#FF8000' : '',
                                                                    display: params.row.is_send == 1 ? 'inline' : 'none'
                                                                }
                                                            },
                                                            params.row.is_send == 1 ? '赠品' : ''
                                                        ),
                                                        h('span', params.row.goodsname)
                                                    ]
                                                ),
                                                h('small', // 商品编号
                                                    '商品编号：' + params.row.commcode
                                                )
                                            ]
                                        ),
                                    ]
                                )
                    }
                },
                {
                    title: '规格',
                    key: 'goodsattrname'
                },
                {
                    title: '数量',
                    key: 'num',
                    render: (h, params) => {
                        if (!params.row.unitshow) {
                            return h('span', params.row.userordernum + params.row.unit)
                        }
                        if (params.row.unitshow) {
                            return h('span', params.row.userordernum + params.row.maxunit)
                        }
                    }
                },
                {
                    title: '单价 (元)',
                    key: 'cost',
                    render: (h, params) => {
                        if (params.row.is_send == 1) {
                            return h('del', params.row.cxinfo.is_cx == 1 ? (params.row.unitshow ? ((params.row.cxinfo.cxcost * params.row.matrixing).toFixed(2)) : params.row.cxinfo.cxcost) : (params.row.unitshow ? ((params.row.cost * params.row.matrixing).toFixed(2)) : params.row.cost))
                        }
                        if (params.row.is_send == 0) {
                            return h('span', params.row.cxinfo.is_cx == 1 ? (params.row.unitshow ? ((params.row.cxinfo.cxcost * params.row.matrixing).toFixed(2)) : params.row.cxinfo.cxcost) : (params.row.unitshow ? ((params.row.cost * params.row.matrixing).toFixed(2)) : params.row.cost))
                        }
                    }
                },
                {
                    title: '小计 (元)',
                    key: 'onegoodssub'
                }
            ],
            goodslist: [], // 表格列表
            goodscount: 0, // 几种商品
            goodsallnum: 0, //	商品总数
            sendgitf: 0, // 是否有赠品 0 没有 1 有
            goodsallcost: 0, // 商品总价
            cxcost:	0, // 促销价
            taxation: 0, // 税费
            pscost:	0, // 运费
            shopcxcost: 0, // 优惠金额
            couponcost: 0, // 优惠券金额
            orderallcost: 0, // 订单总价
            tableShow: false, // 表格 展开/收起
            ggids: '', // gg_id规格集
            nums: '', // 数量集合
            remarks: '', // 备注集合
            unitshows: '', // 大小单位集合
            billed: '0', // 发票选中 0 不开发票 1 普通 2 增值
            couponShow: false, // 查看优惠券信息弹窗
            couponinfo: {}, // 点击选中优惠券信息
            submit: {
                delivertime: '', // 交货日期
                shopyhqid: 0, // 优惠券id
                cxid: 0, // 店铺优惠活动id 暂时不用
                companyname: '', // 公司名称
                takeaddressdet: '', // 收货人详情地址
                takegoodsname: '', // 收货人名称
                takegoodsphone: 0, // 收货人电话
                takeadcode: '', // 收货人地址 省-市-区 code
                takeareaname: '', // 收货人地址名称 省-市-区
                content: '', // 订单备注
                ordertype: 0, // 下单方式 0 自主下单 1 代客下单
                orderfrom: 0, // 订单来源 0 pc 1 APP 2 微信
                billset: { // 发票设置
                    status: 0, // 是否可用发票 1可用 0不可用
                    is_sptcommen: 0, // 普通类型发票是否可用1可用 0不可用
                    commentaxrate: 0, // 普通类型发票税率
                    is_sptzeng: 0, // 增值税发票1可用 0不可用
                    zengtaxrate: 0, // 增值税类型发票税率
                },
                billinfo: { // 发票信息
                    billtitle: "", // 发票抬头
                    billnumber: "", // 纳税人识别号
                    billcontent: "", // 发票内容
                    regaddress: "", // 注册地址
                    regphone: "", // 注册电话
                    bankuser: "", // 开户名称
                    bankname: "", // 开户银行
                    banknumber: "", // 银行账号
                }
            }
        }
    },
    computed: {
        orderprice () { // 订单金额
            let price = parseFloat(this.goodsallcost) + parseFloat(this.taxation) - parseFloat(this.shopcxcost) - parseFloat(this.couponcost) <= 0 ? 0 : (parseFloat(this.goodsallcost) + parseFloat(this.taxation) - parseFloat(this.shopcxcost) - parseFloat(this.couponcost)).toFixed(2)
            
            return (parseFloat(price) + parseFloat(this.pscost)).toFixed(2)
        }
    },
    methods: {
        getggids () { // 初始化获取 gg_id - num - remarks
            this.ggids = this.$route.params.ggid
            
            let ggids = []
            let nums = []
            let remarks = []
            let unitshows = []

            if (this.$route.params.ggid.indexOf(',') == -1) {
                for (var i = 0; i < this.$store.state.shopcartlist.length; i++) {
                    if (this.$store.state.shopcartlist[i].gg_id == this.ggids) {
                        this.nums = this.$store.state.shopcartlist[i].num
                        this.remarks = this.$store.state.shopcartlist[i].remarks
                        this.unitshows = this.$store.state.shopcartlist[i].unitshow
                    }
                }
            } else {
                ggids = this.$route.params.ggid.split(',')
                for (var i = 0; i < ggids.length; i++) {
                    for (var j = 0; j < this.$store.state.shopcartlist.length; j++) {
                        if (ggids[i] == this.$store.state.shopcartlist[j].gg_id) {
                            nums.push(this.$store.state.shopcartlist[j].num)
                            remarks.push(this.$store.state.shopcartlist[j].remarks)
                            unitshows.push(this.$store.state.shopcartlist[j].unitshow)
                        }
                    }
                }
                this.nums = nums.join(',')
                this.remarks = remarks.join(',')
                this.unitshows = unitshows.join(',')
            }
        },
        getInfo () { // 获取订单信息
            this.http.post(api.confirmorder,
                {
                    gg_ids: this.ggids,
                    goodsnums: this.nums,
                    remarks: this.remarks,
                    unitshow: this.unitshows,
                }
            )
            .then(response => {
                console.log(response.data.msg)
                if (response.data.msg.addresslist.length > 0) {
                    for (var i = 0; i < response.data.msg.addresslist.length; i++) {
                        response.data.msg.addresslist[i].is_main == 1 ? response.data.msg.addresslist[i].selected = true : response.data.msg.addresslist[i].selected = false
                        
                        if (response.data.msg.addresslist[i].selected == true) {
                            // 公司名称
                            this.submit.companyname = response.data.msg.addresslist[i].shopname
                            // 详细地址
                            this.submit.takeaddressdet = response.data.msg.addresslist[i].detaddress
                            // 收货人名字
                            this.submit.takegoodsname = response.data.msg.addresslist[i].contactname
                            // 收货人电话
                            this.submit.takegoodsphone = response.data.msg.addresslist[i].phone
                            // 城市id 省,市,区
                            this.submit.takeadcode = response.data.msg.addresslist[i].fathercode + ',' + response.data.msg.addresslist[i].cityadcode + ',' + response.data.msg.addresslist[i].adcode
                            // 收货人地址名称 省-市-区
                            this.submit.takeareaname = response.data.msg.addresslist[i].fathercodename + ',' + response.data.msg.addresslist[i].cityadcodename + ',' + response.data.msg.addresslist[i].areaaddress
                        }
                    }
                    this.addresslist = response.data.msg.addresslist
                    this.is_sendtime = response.data.msg.is_sendtime
                }
                if (response.data.msg.juanlist.length > 0) {
                    for (var i = 0; i < response.data.msg.juanlist.length; i++) {
                        response.data.msg.juanlist[i].checked = false
                        if (response.data.msg.juanlist[0].availstatus == 1) {
                            response.data.msg.juanlist[0].checked = true
                            this.couponcost = response.data.msg.juanlist[0].cost
                            this.submit.shopyhqid = response.data.msg.juanlist[0].id
                        }
                    }
                }
                this.submit.billset = response.data.msg.billset
                this.submit.billinfo = response.data.msg.billinfo
                this.goodslist = response.data.msg.newshoplist.goodslist
                this.goodscount = response.data.msg.newshoplist.goodscount
                this.goodsallnum = response.data.msg.newshoplist.goodsallnum
                this.sendgitf = response.data.msg.newshoplist.sendgitf
                this.goodsallcost = response.data.msg.newshoplist.goodsallcost
                this.cxcost = response.data.msg.newshoplist.cxcost
                this.pscost = response.data.msg.newshoplist.pscost
                this.shopcxcost = response.data.msg.newshoplist.shopcxcost
                this.orderallcost = response.data.msg.newshoplist.orderallcost
                this.couponlist = response.data.msg.juanlist
            })
            .catch(error => {
                console.log(error);
            })
        },
        getpscost () { // 获取配送费 - 更改地址后重新获取的配送费
            this.http.post(api.confirmorder,
                {
                    gg_ids: this.ggids,
                    goodsnums: this.nums,
                    remarks: this.remarks,
                    unitshow: this.unitshows,
                    takeadcode: this.submit.takeadcode,
                }
            )
            .then(response => {
                console.log(response.data.msg.newshoplist.pscost)
                this.pscost = response.data.msg.newshoplist.pscost
            })
            .catch(error => {
                console.log(error);
            })
        },
        dateChange (e) { // 选择日期
            this.submit.delivertime = e
        },
        showalladdressClick () { // 收货地址 展开/收起
            this.addressShow = !this.addressShow
        },
        selectaddress (item, index) { // 选择收货地址
            for (var i = 0; i < this.addresslist.length; i++) {
                this.addresslist[i].selected = false
            }
            item.selected = true
            // 公司名称
            this.submit.companyname = item.shopname
            // 详细地址
            this.submit.takeaddressdet = item.detaddress
            // 收货人名字
            this.submit.takegoodsname = item.contactname
            // 收货人电话
            this.submit.takegoodsphone = item.phone
            // 城市id 省,市,区
            this.submit.takeadcode = item.fathercode + ',' + item.cityadcode + ',' + item.adcode
            // 收货人地址名称 省-市-区
            this.submit.takeareaname = item.fathercodename + ',' + item.cityadcodename + ',' + item.adcodename
            // 重新获取配送费
            this.getpscost()
        },
        showalltable () { // 显示/隐藏 全部商品
            this.tableShow = !this.tableShow
        },
        newaddressClick () { // 新建地址
            this.newaddresshows = true
        },
        newaddressOk (e) { // 新建地址弹窗确定
            for (var i = 0; i < this.addresslist.length; i++) {
                this.addresslist[i].selected = false
            }
            let newaddress = {
                shopname: "", // 公司名称
                contactname: "", // 姓名
                phone: "", // 电话
                fathercode: "", // 省 code
                cityadcode: "", // 市 code
                adcode: "", // 区/县 code
                fathercodename: "", // 省 文字
                cityadcodename: "", // 市 文字
                adcodename: "", // 区/县 文字
                detaddress: "", // 详细地址
                is_main: 0, // 是否为默认地址 1 是
                selected: true,
            }
            this.submit.companyname = newaddress.shopname = e.company
            this.submit.takegoodsname = newaddress.contactname = e.name
            this.submit.takegoodsphone = newaddress.phone = e.phone
            newaddress.fathercode = e.citycode[0]
            newaddress.cityadcode = e.citycode[1]
            newaddress.adcode = e.citycode[2] || ''
            newaddress.fathercodename = e.city[0]
            newaddress.cityadcodename = e.city[1]
            newaddress.adcodename = e.city[2] || ''
            this.submit.takeaddressdet = newaddress.detaddress = e.address

            // 城市id 省,市,区
            this.submit.takeadcode = e.citycode[0] + ',' + e.citycode[1] + ',' + (e.citycode[2] || '')
            // 收货人地址名称 省-市-区
            this.submit.takeareaname = e.city[0] + ',' + e.city[1] + ',' + (e.city[2] || '')
            this.addresslist.unshift(newaddress)
            this.newaddresshows = false
            // 重新获取配送费
            this.getpscost()
        },
        newaddressCancel () { // 新建地址弹窗取消
            this.newaddresshows = false
        },
        billChange (e) { // 选择发票
            let num = 0
            if (e == 0) {
                this.taxation = num.toFixed(2)
            } else if (e == 1) {
                this.taxation = ((this.goodsallcost - 0 - 0) * (this.submit.billset.commentaxrate / 100)).toFixed(2)
            } else if (e == 2) {
                this.taxation = ((this.goodsallcost - 0 - 0) * (this.submit.billset.zengtaxrate / 100)).toFixed(2)
            }
        },
        invoiceClick () { // 修改发票信息
            this.invoiceshows = true
        },
        invoiceOk (e) { // 发票弹窗确认按钮
            if (this.billed == 1) {
               this.submit.billinfo.billtitle = e.title
               this.submit.billinfo.billnumber = e.number
               this.submit.billinfo.billcontent = e.content
            }
            if (this.billed == 2) {
                this.submit.billinfo.billtitle = e.title
                this.submit.billinfo.billnumber = e.number
                this.submit.billinfo.regaddress = e.address
                this.submit.billinfo.regphone = e.phone
                this.submit.billinfo.bankname = e.bankname
                this.submit.billinfo.banknumber = e.banknumber
                this.submit.billinfo.billcontent = e.content
            }
            this.invoiceshows = false
        },
        invoiceCancel () { // 发票弹窗关闭
            this.invoiceshows = false
        },
        couponshow () { // 展开全部优惠券
            this.couponheight = !this.couponheight
        },
        selectcoupon (item, index) { // 选择优惠券
            if (item.availstatus == 1) {
                if (item.id == this.submit.shopyhqid) {
                    item.checked = !item.checked
                    item.checked ? this.couponcost = item.cost : this.couponcost = 0
                } else {
                    for (var i = 0; i < this.couponlist.length; i++) {
                        this.couponlist[i].checked = false
                    }
                    this.couponlist[index].checked = true
                    this.couponcost = item.cost
                }
                item.checked ? this.submit.shopyhqid = item.id : this.submit.shopyhqid = ''
            }
        },
        seecouponinfo (item) { // 查看优惠券信息
            this.couponinfo = item
            this.couponShow = true
        },
        couponCancel () { // 关闭查看优惠券信息弹窗
            this.couponShow = false
        },
        goto (id) { // 跳转商品详情页
            this.$router.push({
                name: '商品详情',
                params: {
                    id: id
                }
            })
        },
        submitorder () { // 提交订单检测商品
            if (this.billed == 1) {
                if (this.submit.billinfo.billtitle == '' || this.submit.billinfo.billnumber == '' || this.submit.billinfo.billcontent == '') {
                    this.$Message.warning('请完善发票信息')
                } else {
                    this.submitcheck()
                }
            } else if (this.billed == 2) {
                if (this.submit.billinfo.billtitle == '' || this.submit.billinfo.billnumber == '' || this.submit.billinfo.billcontent == '' || this.submit.billinfo.regaddress == '' || this.submit.billinfo.regphone == '' || this.submit.billinfo.bankname == '' || this.submit.billinfo.banknumber == '') {
                    this.$Message.warning('请完善发票信息')
                } else {
                    this.submitcheck()
                }
            } else {
                this.submitcheck()
            }
        },
        submitcheck () { // 检测是否可以提交订单
            let ggidsarr = []
            let numsarr = []
            let unitshowsarr = []
            for (var i = 0; i < this.goodslist.length; i++) {
                ggidsarr.push(this.goodslist[i].gg_id)
                numsarr.push(this.goodslist[i].num)
                unitshowsarr.push(this.goodslist[i].unitshow)
            }

            this.http.post(api.goodscheck,
                {
                    gid: ggidsarr.join(','),
                    goodnum: numsarr.join(','),
                    unitshow: unitshowsarr.join(','),
                }
            )
            .then(response => {
                console.log(response.data.msg)
                this.suborderinfo()
            })
            .catch(error => {
                this.$Message.error(error)
            })
        },
        suborderinfo () { // 提交订单
            this.http.post(api.submitorder,
                {    
                    gg_ids: this.ggids,
                    goodsnums: this.nums,
                    remarks: this.remarks,
                    unitshow: this.unitshows,
                    delivertime: this.submit.delivertime,
                    shopyhqid: this.submit.shopyhqid,
                    cxid: this.submit.cxid,
                    companyname: this.submit.companyname,
                    takeaddressdet: this.submit.takeaddressdet,
                    takegoodsphone: this.submit.takegoodsphone,
                    takeadcode: this.submit.takeadcode,
                    takegoodsname: this.submit.takegoodsname,
                    takeareaname: this.submit.takeareaname,
                    billtype: this.billed,
                    content: this.submit.content,
                    ordertype: 0,
                    orderfrom: 0,
                    billtitle: this.submit.billinfo.billtitle,
                    billnumber: this.submit.billinfo.billnumber,
                    billcontent: this.submit.billinfo.billcontent,
                    regaddress: this.submit.billinfo.regaddress,
                    regphone: this.submit.billinfo.regphone,
                    bankuser: this.submit.billinfo.bankuser,
                    bankname: this.submit.billinfo.bankname,
                    banknumber: this.submit.billinfo.banknumber,
                }
            )
            .then(response => {
                console.log(response.data.msg)
                if (response.data.msg.id != null) {
                    this.$router.push({
                        name: '支付',
                        params: {
                            type: 0, // 0 订单 1 充值
                            id: response.data.msg.id
                        }
                    })
                    this.$store.dispatch('delShopCartListFun', this.ggids.split(','))
                } else {
                    this.$Message.warning('订单出错，请重新下单')
                }
            })
            .catch(error => {
                this.$Message.error(error)
            })
        }
    },
    created () {
        this.getggids()
        this.getInfo()
    },
    filters: {
        moneyFilter (money) {
            return toMoney(money)
        }
    }
}
</script>

<style scoped>

.orderinfo_title_content {
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 30px;
    background-color: #E7EBF6;
    border-radius: 4px 4px 0 0;
}

.orderinfo_title_content > h3 {
    height: 16px;
    line-height: 16px;
    margin-top: 1px;
    font-size: 16px;
    color: #333;
    font-weight: normal;
}

.orderinfo_info_content {
    padding-top: 20px;
}

.orderinfo_info_content .ivu-form-item {
    margin-bottom: 17px;
}

.orderinfo_list_box {
    width: 400px;
    line-height: initial;
    padding: 2px 10px 7px;
    margin-bottom: 10px;
    background-color: #fff;
    border: 1px solid #F2F2F2;
    border-radius: 4px;
    cursor: pointer;
    overflow: hidden;
    position: relative;
}

.orderinfo_list_box::after {
    content: '✔';
    width: 0;
    height: 0;
    line-height: 9px;
    text-align: center;
    font-size: 10px;
    color: #fff;
    display: none;
    border-top: 10px solid transparent;
    border-left: 15px solid transparent;
    border-right: 15px solid #FF8000;
    border-bottom: 10px solid #FF8000;
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 1;
}

.orderinfo_list {
    padding-top: 4px;
    font-size: 14px;
    color: #666;
}

.orderinfo_list > span,
.orderinfo_list > small,
.orderinfo_list > b {
    color: #666;
    font-weight: normal;
}

.orderinfo_list > small {
    margin-right: 20px;
}

.orderinfo_list_box.active {
    background-color: #FDF5EC;
    border-color: #FF8000;
}

.orderinfo_list_box.active::after {
    display: block;
}

.orderinfo_btn_content {
    line-height: initial;
    margin-top: 7px;
    font-size: 0;
}

.orderinfo_btn_content > span {
    margin: 0 10px;
    font-size: 16px;
    color: #FF8000;
    cursor: pointer;
}

.orderinfo_goodsinfo_content {
    padding: 20px 30px;
}

.orderinfo_goodsinfo_box {
    height: 124px;
    overflow: hidden;
}

.orderinfo_goodsinfo_box.active {
    height: auto;
}

.orderinfo_goodsinfo_btn {
    padding-top: 17px;
    text-align: center;
}

.orderinfo_goodsinfo_btn > span {
    font-size: 14px;
    color: #FF8000;
    cursor: pointer;
}

.orderinfo_footer_content {
    background-color: #fff;
    position: sticky;
    bottom: 0;
    z-index: 10;
}

.orderinfo_footer_box {
    min-height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 10px 30px;
}

.orderinfo_footer_left {
    display: flex;
    flex-direction: row;
}

.orderinfo_footer_list {
    margin-right: 30px;
}

.orderinfo_footer_list:last-child {
    margin-right: 0;
}

.orderinfo_footer_list > span {
    font-size: 14px;
    color: #666;
}

.orderinfo_footer_list > b {
    font-size: 14px;
    color: #333;
}

.orderinfo_footer_right {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.orderinfo_footer_right > button {
    font-size: 16px;
}

.orderinfo_footer_money {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 20px;
}

.orderinfo_footer_money > span {
    margin-top: 6px;
    font-size: 14px;
    color: #333;
}

.orderinfo_footer_money > b {
    font-size: 20px;
    color: #FF3333;
}

.invoice_info_content {
    display: flex;
    flex-direction: row;
    padding-top: 10px;
    line-height: initial;
}

.invoice_info_content i {
    margin-right: 6px;
    font-size: 12px;
    color: #FF8000;
    cursor: pointer;
}

.invoice_info_content > p {
    width: 10px;
    flex-grow: 1;
    flex-shrink: 1;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: -3px;
}

.invoice_info_content > p > span {
    margin-right: 14px;
    font-size: 14px;
    color: #666;
}

.orderinfo_coupon_content > span {
    font-size: 14px;
    color: #999;
    cursor: pointer;
}

.orderinfo_coupon_box {
    min-width: 528px;
    max-width: 1046px;
    height: 120px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: -20px;
    line-height: initial;
    overflow: hidden;
}

.orderinfo_coupon_box li {
    width: 240px;
    height: 100px;
    /* margin: 0 20px 20px 0; */
    border: 1px solid #f0f0f0;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
}

.orderinfo_coupon_box li i.icon {
    height: 16px;
    line-height: 16px;
    font-size: 16px;
    color: #FF8000;
    display: none;
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 1;
}

.orderinfo_coupon_box li.active {
    border-color: #FF8000;
}

.orderinfo_coupon_box li.active i.icon {
    display: block;
}

.orderinfo_coupon_top {
    height: 68px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background-color: #FF8000;
}

.orderinfo_coupon_price {
    width: 112px;
    flex-grow: 0;
    flex-shrink: 0;
    text-align: center;
    font-size: 26px;
    color: #fff;
}

.orderinfo_coupon_price::first-letter {
    font-size: 14px;
}

.orderinfo_coupon_info {
    flex-grow: 1;
    flex-shrink: 1;
    display: flex;
    flex-direction: column;
}

.orderinfo_coupon_info > span {
    font-size: 14px;
    color: #fff;
}

.orderinfo_coupon_info > small {
    font-size: 12px;
    color: #fff;
}

.orderinfo_coupon_bottom {
    height: 32px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
}

.orderinfo_coupon_bottom > span {
    font-size: 12px;
    color: #666;
}

.orderinfo_coupon_bottom > span:nth-child(1) {
    width: 10px;
    flex-grow: 1;
    flex-shrink: 1;
    padding-right: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.orderinfo_coupon_bottom > span:nth-child(2) {
    flex-grow: 0;
    flex-shrink: 0;
}

.orderinfo_coupon_box li.no .orderinfo_coupon_top {
    background-color: #D8D8D8;
}

.orderinfo_coupon_box li.no .orderinfo_coupon_price,
.orderinfo_coupon_box li.no .orderinfo_coupon_info > span,
.orderinfo_coupon_box li.no .orderinfo_coupon_info > small {
    color: #666;
}

</style>


// WEBPACK FOOTER //
// src/components/views/shoppingcart/orderinfo.vue